export default class StatusOperacao {
    static get AGUARDANDO_APROVACAO() {
        return 1;
    }

    static get APROVADO() {
        return 2;
    }

    static get CANCELADO() {
        return 3;
    }

    static get REPROVADO() {
        return 4;
    }

    static get EDITADO() {
        return 5;
    }

    static get EM_ANALISE() {
        return 6;
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return StatusOperacao[name];
    }
}
